import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="mt-auto border-t border-border/20">
      {/* Bottom bar */}
      <div className="flex flex-row items-center justify-between px-6 py-3 text-xs text-muted-foreground/40">
        <span className="tracking-wide">© 2026 AppleSMP™. All rights reserved.</span>
        <span className="flex items-center gap-1.5">
          <Link
            to="/"
            className="transition-colors hover:text-muted-foreground/60"
          >
            Official AppleSMP Website
          </Link>
          <img
            src="https://storage.readdy-site.link/project_files/520edd13-5f79-4106-acab-e65aa072f983/af73a29b-2293-4869-82a9-14c04321e157_server-icon.png?v=a9cbf51f53771ede9685801f64496bc2"
            alt="AppleSMP"
            width={16}
            height={16}
            className="inline-block opacity-50 object-contain"
          />
        </span>
      </div>
    </footer>
  );
}
